export default __webpack_public_path__ + "static/media/rocket_anim_133.f81910bd.png";